module.exports = __webpack_public_path__ + "static/media/falsyicon.69a9a5b3.svg";